import { render, staticRenderFns } from "./Rujukan.vue?vue&type=template&id=12529487&"
import script from "./Rujukan.vue?vue&type=script&lang=js&"
export * from "./Rujukan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports